import Tile from './Tile'

export * from './Tile'
export default Tile
